import styles from './LandingProfileSkeleton.module.css'

function Bone({ className = '' }: { className?: string }) {
  return <span className={`${styles.bone} ${className}`} />
}

export function LandingProfileSkeleton() {
  return (
    <div
      className={styles.page}
      role="status"
      aria-live="polite"
      aria-label="Carregando sua área da campanha"
    >
      <span className={styles.screenReader}>Carregando sua área da campanha...</span>
      <div aria-hidden="true">
        <header className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.heroNav}>
              <Bone className={styles.navButton} />
              <Bone className={styles.navButtonShort} />
            </div>
            <div className={styles.heroCopy}>
              <Bone className={styles.heroPill} />
              <Bone className={styles.heroEyebrow} />
              <Bone className={styles.heroTitle} />
              <Bone className={styles.heroSubtitle} />
            </div>
          </div>
        </header>

        <main className={styles.main}>
          <div className={styles.workspace}>
            <div className={styles.identityColumn}>
              <section className={`${styles.card} ${styles.identity}`}>
                <div className={styles.identityHeader}>
                  <Bone className={styles.identityKicker} />
                  <Bone className={styles.tinySpark} />
                </div>
                <Bone className={styles.avatar} />
                <Bone className={styles.name} />
                <Bone className={styles.email} />
                <div className={styles.stats}>
                  <Bone className={styles.stat} />
                  <Bone className={styles.stat} />
                </div>
                <Bone className={styles.progress} />
              </section>
              <Bone className={styles.purchase} />
            </div>

            <section className={`${styles.card} ${styles.journey}`}>
              <Bone className={styles.sectionKicker} />
              <Bone className={styles.sectionTitle} />
              <Bone className={styles.sectionSubtitle} />
              <div className={styles.badges}>
                {Array.from({ length: 5 }, (_, index) => (
                  <div className={styles.badge} key={index}>
                    <Bone className={styles.badgeImage} />
                    <Bone className={styles.badgeLabel} />
                  </div>
                ))}
              </div>
              <Bone className={styles.mission} />
            </section>

            <section className={`${styles.card} ${styles.ranking}`}>
              <Bone className={styles.sectionKicker} />
              <Bone className={styles.sectionTitle} />
              <Bone className={styles.sectionSubtitle} />
              {[0, 1, 2, 3].map((index) => (
                <div
                  className={`${styles.rankRow} ${index === 0 ? styles.rankFirst : ''}`}
                  key={index}
                >
                  <Bone className={styles.rankAvatar} />
                  <Bone className={styles.rankName} />
                  <Bone className={styles.rankAmount} />
                </div>
              ))}
            </section>

            <section className={`${styles.card} ${styles.numbers}`}>
              <div className={styles.tabBar}>
                <Bone className={styles.tabArrow} />
                <Bone className={styles.tabTitle} />
                <Bone className={styles.tabArrow} />
              </div>
              <Bone className={styles.sectionTitle} />
              <Bone className={styles.sectionSubtitle} />
              <Bone className={styles.numberRow} />
              <Bone className={styles.numberRow} />
            </section>
          </div>
        </main>
        <div className={styles.dock}>
          {Array.from({ length: 5 }, (_, index) => (
            <div className={styles.dockItem} key={index}>
              <Bone className={styles.dockIcon} />
              <Bone className={styles.dockLabel} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
